var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 54,
    viewBox: "0 0 44 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2427 0.0343018H32.6289V3.57225H11.4012V0.0343018H0.787415V53.1035H11.4012V49.5655H32.6289V53.1035H43.2427V0.0343018ZM7.8633 3.57225V7.11019H4.32536V3.57225H7.8633ZM39.7048 3.57225V7.11019H36.1669V3.57225H39.7048ZM32.6289 7.11019V24.7999H11.4012V7.11019H32.6289ZM7.8633 10.6481V14.1861H4.32536V10.6481H7.8633ZM39.7048 10.6481V14.1861H36.1669V10.6481H39.7048ZM7.8633 17.724V21.262H4.32536V17.724H7.8633ZM39.7048 17.724V21.262H36.1669V17.724H39.7048ZM7.8633 24.7999V28.3379H4.32536V24.7999H7.8633ZM39.7048 24.7999V28.3379H36.1669V24.7999H39.7048ZM32.6289 28.3379V46.0276H11.4012V28.3379H32.6289ZM7.8633 31.8758V35.4137H4.32536V31.8758H7.8633ZM39.7048 31.8758V35.4137H36.1669V31.8758H39.7048ZM7.8633 38.9517V42.4896H4.32536V38.9517H7.8633ZM39.7048 38.9517V42.4896H36.1669V38.9517H39.7048ZM7.8633 46.0276V49.5655H4.32536V46.0276H7.8633ZM39.7048 46.0276V49.5655H36.1669V46.0276H39.7048Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector (1).84da246122507790575d70080d336352.svg";
export { ForwardRef as ReactComponent };